module.exports = __webpack_public_path__ + "static/img/1.fa65396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/1.jpg
// module id = ukjF
// module chunks = 4